/**
 * api接口统一管理
 */
import { get, post } from './http'
/**
 * 获取新闻列表接口（GET）
 * @param {Object} p 请求参数
 */
export const getNewsList = p => get('/web/news/v2/getalllist', p)

/**
 * 获取新闻详情接口（GET）
 * @param {Object} p 请求参数
 */
export const getNewsDetails = p => get('/web/news/v2/selectdatabyid', p)

/**
 * 获取视频列表接口（GET）
 * @param {Object} p 请求参数
 */
export const getVideosList = p => get('/web/video/v2/getlistbyvtype', p)

/**
 * 获取视频详情接口（GET）
 * @param {Object} p 请求参数
 */
export const getVideosDetails = p => get('/web/video/v2/selectdatebyid', p)


/**
 * 获取微信客服群二维码接口（GET）
 * @param {Object} p 请求参数
 */
export const getWeChatGroupData = p => get('/api/v1/common/queryparambyname', p)

export const getsysparam = p => get('/api/v1/common/queryparambyname', p)

/**
 * 获取安装包链接接口（GET）
 * @param {Object} p 请求参数
 */
export const getInstallPackUrl = p => get('/upgradePackage/infoall', p)

/**
 *
 * @param {Object} p 请求参数
 */
 export const getclicks = p => post('/api/v1/log/packagedownload', p)


 export const getVisit = p => post('/api/v1/log/visit', p)


 /**
  * 微信登录
  * @param {*} p
  * @returns
  */
 export const saveloginrecord = p => post('/api/v1/pc/saveloginrecord', p)


 /**
  * 活动信息
  * @param {*} p
  * @returns
  */
 export const getlistActivity = p => get('/web/activitie/v2/getlist', p)

 /**
  * 摄影大赛落地页访问接口
  * @param {*} p
  * @returns
  */
 export const bhphotography = p => post('/web/activitie/v2/view', p)


/**
 * 企业会员咨询提交接口
 * @param {*} p
 * @returns
 */
export const addConsult = p => post('/sales/order/addConsult', p)

/**
 * 摄影大赛作品数据
 * @param {*} p
 * @returns
 */
 export const getdetail = p => get('/api/v1/pc/activety/photo/getdetail', p)

 /**
 * 获取活动数据
 * @param {*} p
 * @returns
 */
  export const activetyData = p => get('/api/v1/pc/activety/photo/get', p)


 /**
 * 点赞
 * @param {*} p
 * @returns
 */
  export const activetyLove = p => post('/api/v2/material/love', p)

  /**
 * paypal支付
 * @param {*} p
 * @returns
 */
export const paypal = p => get('/paypal/api/v1/pay/create', p)


  /**
 * 获取用户信息
 * @param {*} p
 * @returns
 */
export const getUserInfo = p => post('/api/v1/pc/getUserInfo', p)

  /**
 * 获取会员价格数据
 * @param {*} p
 * @returns
 */
export const vipPric = p => get('/web/sales/vipprice/v2/listpage', p)

// /**
//  * 获取商品列表接口：
//  api/vi/app/googlepay/list
//  方式：get
//  参数：type（这里你直接传 AITIMES）
//  返回：code、data
//  */
// export const googlePric = p => get('/api/vi/app/googlepay/list', p)

/**
 * 支付成功接口：
 api/vi/app/googlepay/googlePayVerify
 方式：post
 参数：transactionId（谷歌的订外部单id）、packageName（应用程序包名）、productId（productId商品id）、purchaseToken（purchaseToken谷歌返回的收据）
 返回：code、data
 */
export const googlePayOk = p => post('/api/vi/app/googlepay/googlePayVerify', p)

/**
 * 获取商品列表接口：
 web/sales/vipprice/v2/listpage
 方式：get
 参数：
 productstype:
 type:
 scopetype:
 返回：code、data
 */
export const getVipListPage = p => get('/web/sales/vipprice/v2/listpage', p)

/**
 * 支付成功接口：
 api/vi/app/iosgoods/applePayVerify
 方式：post
 参数：transactionId（谷歌的订外部单id）、packageName（应用程序包名）、productId（productId商品id）、purchaseToken（purchaseToken谷歌返回的收据）
 返回：code、data
 */
export const applePayOk = p => post('/api/vi/app/iosgoods/applePayVerify', p)








// WEBPACK FOOTER //
// ./src/utils/api.js